import { render, staticRenderFns } from "./ChangelogEdit.vue?vue&type=template&id=e685ff4e"
import script from "./ChangelogEdit.vue?vue&type=script&lang=js"
export * from "./ChangelogEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e685ff4e')) {
      api.createRecord('e685ff4e', component.options)
    } else {
      api.reload('e685ff4e', component.options)
    }
    module.hot.accept("./ChangelogEdit.vue?vue&type=template&id=e685ff4e", function () {
      api.rerender('e685ff4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/changelog/ChangelogEdit.vue"
export default component.exports